"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCvSourceSuggestions = exports.getCompanySuggestions = exports.getPositionSuggestions = exports.getGenderFromName = exports.getLanguageFromText = exports.getTimezone = exports.extractPlaceInfo = exports.getPlaceInfoById = exports.getCitySuggestions = void 0;
var tslib_1 = require("tslib");
// @ts-nocheck
var api_1 = tslib_1.__importStar(require("./api"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var staticData_store_1 = tslib_1.__importDefault(require("./stores/staticData.store"));
var SIXTY_SECONDS = 60000;
var athenaEchoAxiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    baseURL: process.env.ATHENA_ECHO_URL ? process.env.ATHENA_ECHO_URL : process.env.REACT_APP_ATHENA_ECHO_URL,
    responseType: 'json',
});
athenaEchoAxiosInstance.interceptors.request.use(function (request) {
    request.headers.Authorization = tokenStorage_1.default.get();
    return request;
});
/**
 *
 * @param {string} placeString
 * @returns {Promise<{ place_id: string, description: string }[]>}
 */
var getCitySuggestions = function (placeString) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var encodedPlaceString, response;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                encodedPlaceString = encodeURIComponent(placeString);
                return [4 /*yield*/, api_1.default
                        .get("/api/googleplaces/autocomplete-places?input=".concat(encodedPlaceString, "&types=(cities)"))
                        .catch(api_1.errorHandler)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) ? response.data.data : response];
        }
    });
}); };
exports.getCitySuggestions = getCitySuggestions;
/**
 *
 * @param {string} placeId
 * @returns {Promise<
 * {
 *  address_components:
 *  {
 *      long_name: string
 *      short_name: string
 *      types: string[]
 *  }[]
 *  formatted_address: string
 *  geometry:
 *  {
 *      bounds:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *      location: { lat: number lng: number}
 *      location_type: string
 *      viewport:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *  }
 *  place_id: string
 *  types: string[]
 * }>}
 */
var getPlaceInfoById = function (placeId) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, api_1.default
                    .get("/api/googleplaces/geocode-by-placeid?placeId=".concat(placeId))
                    .catch(api_1.errorHandler)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) ? response.data.data[0] : response];
        }
    });
}); };
exports.getPlaceInfoById = getPlaceInfoById;
/**
 *
 * @param {{
 *  address_components:
 *  {
 *      long_name: string
 *      short_name: string
 *      types: string[]
 *  }[]
 *  formatted_address: string
 *  geometry:
 *  {
 *      bounds:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *      location: { lat: number lng: number}
 *      location_type: string
 *      viewport:
 *      {
 *          northeast:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *          southwest:
 *          {
 *              lat: number
 *              lng: number
 *          }
 *      }
 *  }
 *  place_id: string
 *  types: string[]
 * }} googlePlace
 * @returns { {
 *  address?: string
 *  city?: string
 *  state?: string
 *  countryId?: number
 *  invoicingRegionId?: number
 *  countryDefaultTimezoneId?: number
 *  postalCode?: string
 *  location: { latitude: number longitude: number}
 * }}
 */
var extractPlaceInfo = function (googlePlace) {
    var address = googlePlace.address_components
        .filter(function (c) {
        return c.types.includes('route') || c.types.includes('street_number');
    })
        .map(function (c) { return c.long_name; })
        .reverse()
        .join(' ');
    var countryComponent = googlePlace.address_components.find(function (c) { return c.types.includes('country'); });
    var countryIsoCode = countryComponent && countryComponent.short_name;
    var city = googlePlace.address_components.find(function (c) { return c.types.includes('locality'); });
    if (!city) {
        city = googlePlace.address_components.find(function (c) {
            return c.types.includes('postal_town') ||
                c.types.includes('administrative_area_level_3') ||
                c.types.includes('sublocality_level_1');
        });
    }
    var state = googlePlace.address_components.find(function (c) { return c.types.includes('administrative_area_level_1'); });
    var postalCodeComponent = googlePlace.address_components.find(function (c) { return c.types.includes('postal_code'); });
    var country = staticData_store_1.default.countries.find(function (c) { return c.isoCode2 === countryIsoCode; });
    var countryId = country && country.id;
    var invoicingRegionId = country && country.invoicingRegionId;
    var timezoneId = country && country.timezoneId;
    var cityName = city && city.long_name;
    var stateName = state && state.long_name;
    var postalCode = postalCodeComponent && postalCodeComponent.long_name;
    var latitude = googlePlace.geometry.location.lat;
    var longitude = googlePlace.geometry.location.lng;
    return {
        address: address || '',
        city: cityName || '',
        state: stateName || '',
        countryId: countryId || null,
        invoicingRegionId: invoicingRegionId || null,
        countryDefaultTimezoneId: timezoneId || null,
        postalCode: postalCode || '',
        location: {
            latitude: latitude,
            longitude: longitude,
        },
    };
};
exports.extractPlaceInfo = extractPlaceInfo;
/**
 *
 * @param {number} latitude
 * @param {number} longitude
 * @returns {Promise<{
 *  dstOffset: number
 *  rawOffset: number
 *  timeZoneId: string
 *  timeZoneName: string
 * }>}
 */
var getTimezone = function (latitude, longitude) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api_1.default
                    .get("/api/timezone/location?latitude=".concat(latitude, "&longitude=").concat(longitude))
                    .catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getTimezone = getTimezone;
/**
 *
 * @param {string} input
 * @returns {{ Languages: {Score: number LanguageCode: string}[] }}
 */
var getLanguageFromText = function (input) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!input) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, athenaEchoAxiosInstance({
                        method: 'post',
                        url: "/athenaEcho",
                        data: { payload: input, service_flag: 'dl' },
                    }).catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getLanguageFromText = getLanguageFromText;
/**
 *
 * @param { { names: { name: string country_iso2?: string }[] } } input
 */
var getGenderFromName = function (input) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api_1.default.post("/api/gender-from-name", input).catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getGenderFromName = getGenderFromName;
/**
 *
 * @param {string} positionString
 * @param {number} limit
 * @returns
 */
var getPositionSuggestions = function (positionString, limit) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var encodedPositionString, baseUrl, response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedPositionString = encodeURIComponent(positionString);
                baseUrl = "/api/typeahead/positions?q=".concat(encodedPositionString);
                if (limit) {
                    baseUrl = baseUrl + "&limit=".concat(limit);
                }
                return [4 /*yield*/, api_1.default.get(baseUrl).catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getPositionSuggestions = getPositionSuggestions;
var getCompanySuggestions = function (companyString) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var encodedCompanyString, response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedCompanyString = encodeURIComponent(companyString);
                return [4 /*yield*/, api_1.default
                        .get("/api/company/typeahead?q=".concat(encodedCompanyString))
                        .catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getCompanySuggestions = getCompanySuggestions;
var getCvSourceSuggestions = function (cvSourceString) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var encodedCvSourceString, response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encodedCvSourceString = encodeURIComponent(cvSourceString);
                return [4 /*yield*/, api_1.default
                        .get("/api/cv-source/typeahead?q=".concat(encodedCvSourceString))
                        .catch(api_1.errorHandler)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
    });
}); };
exports.getCvSourceSuggestions = getCvSourceSuggestions;
